
export const OptionsConstants = {
    variables: {
        months: {
            th: {
                fn: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                sn: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
            },
            en: {
                fn: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                sn: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            }
        }
    },
    months: {
        default: {
            defaulted: true,
            options: [
                {   id: '1', 
                    label: 'มกราคม',
                    value: '1',
                },
                {   id: '2', 
                    label: 'กุมภาพันธ์',
                    value: '2',
                },
                {   id: '3', 
                    label: 'มีนาคม',
                    value: '3',
                },
                {   id: '4', 
                    label: 'เมษายน',
                    value: '4',
                },                
                {   id: '5', 
                    label: 'พฤษภาคม',
                    value: '5',
                },                
                {   id: '6', 
                    label: 'มิถุนายน',
                    value: '6',
                },                
                {   id: '7', 
                    label: 'กรกฎาคม',
                    value: '7',
                },                
                {   id: '8', 
                    label: 'สิงหาคม',
                    value: '8',
                },                
                {   id: '9', 
                    label: 'กันยายน',
                    value: '9',
                },                
                {   id: '10', 
                    label: 'ตุลาคม',
                    value: '10',
                },                
                {   id: '11', 
                    label: 'พฤศจิกายน',
                    value: '11',
                },                
                {   id: '12', 
                    label: 'ธันวาคม',
                    value: '12',
                },                
            ],
        },
    },

    register_type: {
        default: {
            defaulted: false,
            options: [
                {   id: '1', 
                    label: 'ผู้เรียน / นักศึกษา',
                    value: '0',
                },
                {   id: '2', 
                    label: 'สถานประกอบการ',
                    value: '1',
                },
            ],
        },
    },

    course_type: {
        default: {
            defaulted: true,
            options: [                
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                },
                {   id: '1', 
                    label: 'Type B',
                    value: 'b',
                },
                {   id: '2', 
                    label: 'Type C',
                    value: 'c',
                },
                {   id: '3', 
                    label: 'Type T',
                    value: 't',
                },
            ],
        },
    },

    operation: {
        external_user_history: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'การจัดการ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },
                {   id: 'work-history', 
                    label: 'ประวัติการทำงาน',
                    value: 'work-history',
                    icon: 'fa-classic fa-regular fa-clock-rotate-left fa-fw',
                    class: '',
                    variant: ''
                },
                {   id: 'training-history', 
                    label: 'ประวัติการฝึกอบรม',
                    value: 'training-history',
                    icon: 'fa-classic fa-regular fa-chalkboard-user fa-fw',
                    class: '',
                    variant: ''
                },
                {   id: 'skills-set', 
                    label: 'ทักษะ (Skill set) ',
                    value: 'skills-set',
                    icon: 'fa-classic fa-regular fa-stars fa-fw',
                    class: '',
                    variant: ''
                },
            ]
        },
        supply_human_resource: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'การจัดการ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },
                {   id: 'in-out', 
                    label: 'นักศึกษา',
                    value: 'in-out',
                    icon: 'fa-classic fa-light fa-graduation-cap fa-fw',
                    class: '',
                    variant: ''
                },
                {   id: 'skills-set', 
                    label: 'Skills Set',
                    value: 'skills-set',
                    icon: 'fa-classic fa-light fa-star-shooting fa-fw',
                    class: '',
                    variant: ''
                },
                {   id: 'industries', 
                    label: 'อุตสาหกรรม',
                    value: 'industries',
                    icon: 'fa-classic fa-light fa-building-circle-check fa-fw',
                    class: '',
                    variant: ''
                }, 
            ]
        },          
        eec_nets_profile: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'การจัดการ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },
                {   id: 'mission', 
                    label: 'ภารกิจ',
                    value: 'mission',
                    icon: 'fa-classic fa-light fa-flag fa-fw',
                    class: '',
                    variant: ''
                },
                {   id: 'operation', 
                    label: 'การดำเนินการของศูนย์',
                    value: 'operation',
                    icon: 'fa-classic fa-light fa-pen-line fa-fw',
                    class: '',
                    variant: ''
                },
                {   id: 'performance', 
                    label: 'ผลการดำเนินงานของศูนย์',
                    value: 'performance',
                    icon: 'fa-classic fa-light fa-chart-line-up fa-fw',
                    class: '',
                    variant: ''
                },  
                {   id: 'plan', 
                    label: 'แผนการดำเนินงานในอนาคต',
                    value: 'future-plans',
                    icon: 'fa-classic fa-light fa-calendar-lines-pen fa-fw',
                    class: '',
                    variant: ''
                },     
                {   id: 'partner', 
                    label: 'หน่วยงานพันธมิตร',
                    value: 'partner',
                    icon: 'fa-classic fa-light fa-handshake fa-fw',
                    class: '',
                    variant: ''
                }, 
                {   id: 'attach', 
                    label: 'ภาพประกอบการ',
                    value: 'attach',
                    icon: 'fa-classic fa-light fa-image fa-fw',
                    class: '',
                    variant: ''
                },                                
            ]
        },
    },

    status: {
        default: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '0', 
                    label: 'ใช้งาน',
                    value: '0',
                    icon: 'fa-classic fa-light fa-circle-check fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '1', 
                    label: 'ไม่ใช้งาน',
                    value: '1',
                    icon: 'fa-classic fa-light fa-ban fa-fw',
                    class: '',
                    variant: 'danger'
                }
            ],
        },
        
        eb01_course_operation_status: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },                               
                {   id: '0', 
                    label: 'รอเสนอ',
                    value: '0',
                    icon: 'fa-classic fa-light fa-hourglass-clock fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },
                {   id: '1', 
                    label: 'รอการแก้ไข',
                    value: '1',
                    icon: 'fa-classic fa-light fa-pen-swirl fa-fw',
                    class: '',
                    variant: 'outline-warning'
                },   
                {   id: '2', 
                    label: 'แก้ไขเสร็จสิ้น',
                    value: '2',
                    icon: 'fa-classic fa-light fa-pen-line fa-fw',
                    class: '',
                    variant: 'outline-info'
                },                                 
                {   id: '3', 
                    label: 'รอการพิจารณา',
                    value: '3',
                    icon: 'fa-classic fa-light fa-inbox-full fa-fw',
                    class: '',
                    variant: 'primary'
                },
            ],
        },          
        eb01_course_approve_status: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },                               
                {   id: '0', 
                    label: 'รับรองหลักสูตร',
                    value: '0',
                    icon: 'fa-classic fa-light fa-shield-check fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '1', 
                    label: 'รับรองหลักสูตรแบบมีเงื่อนไข',
                    value: '1',
                    icon: 'fa-classic fa-regular fa-star fa-fw',
                    class: '',
                    variant: 'info'
                },                 
                {   id: '2', 
                    label: 'ไม่รับรองหลักสูตร',
                    value: '2',
                    icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
                    class: '',
                    variant: 'danger'
                },
            ],
        },   
        eb02_course_eec_hdc: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },                
                {   id: '0', 
                    label: 'เห็นสมควรอนุมัติ',
                    value: '0',
                    icon: 'fa-classic fa-light fa-shield-check fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '1', 
                    label: 'ไม่สมควรอนุมัติ',
                    value: '1',
                    icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
                    class: '',
                    variant: 'warning'
                }                
            ]
        },   
        eb02_course_authorize: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'ผู้มีอำนาจ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },                  
                {   id: '0', 
                    label: 'อนุมัติ',
                    value: '0',
                    icon: 'fa-classic fa-light fa-shield-check fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '1', 
                    label: 'ไม่อนุมัติ',
                    value: '1',
                    icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
                    class: '',
                    variant: 'warning'
                }                
            ]
        },     
        eb02_course_status: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },                               
                {   id: '0', 
                    label: 'ขอจัดอบรม',
                    value: '0',
                    icon: 'fa-classic fa-light fa-arrow-right-to-arc fa-fw',
                    class: '',
                    variant: 'primary'
                },
                {   id: '1', 
                    label: 'อนุมัติจัดอบรม',
                    value: '1',
                    icon: 'fa-classic fa-light fa-badge-check fa-fw',
                    class: '',
                    variant: 'success'
                }, 
                {   id: '2', 
                    label: 'อยู่ระหว่างอบรม',
                    value: '2',
                    icon: 'fa-classic fa-light fa-hourglass-clock fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '3', 
                    label: 'อบรมเสร็จสิ้น',
                    value: '3',
                    icon: 'fa-classic fa-light fa-lock fa-fw',
                    class: '',
                    variant: 'dark'
                },                                                
            ]
        },     
        eb03_training_status: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },                               
                {   id: '1', 
                    label: 'อนุมัติจัดอบรม',
                    value: '1',
                    icon: 'fa-classic fa-light fa-badge-check fa-fw',
                    class: '',
                    variant: 'success'
                }, 
                {   id: '2', 
                    label: 'อยู่ระหว่างอบรม',
                    value: '2',
                    icon: 'fa-classic fa-light fa-hourglass-clock fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '3', 
                    label: 'อบรมเสร็จสิ้น',
                    value: '3',
                    icon: 'fa-classic fa-light fa-lock fa-fw',
                    class: '',
                    variant: 'dark'
                },                                                
            ]
        },                      
        publicize: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '0', 
                    label: 'ร่างข้อมูล',
                    value: '0',
                    icon: 'fa-classic fa-light fa-pen fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },                
                {   id: '1', 
                    label: 'อนุมัติ',
                    value: '1',
                    icon: 'fa-classic fa-light fa-shield-check fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '2', 
                    label: 'ไม่อนุมัติ',
                    value: '2',
                    icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
                    class: '',
                    variant: 'warning'
                },
                {   id: '3', 
                    label: 'ไม่ใช้งาน',
                    value: '3',
                    icon: 'fa-classic fa-light fa-ban fa-fw',
                    class: '',
                    variant: 'danger'
                },
            ],
        },        
        external_user: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '2', 
                    label: 'ลงทะเบียนใหม่',
                    value: '2',
                    icon: 'fa-classic fa-light fa-sparkles fa-fw',
                    class: '',
                    variant: 'primary'
                },
                {   id: '0', 
                    label: 'อนุมัติการใช้งาน',
                    value: '0',
                    icon: 'fa-classic fa-light fa-shield-check fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '3', 
                    label: 'พักการใช้งาน',
                    value: '3',
                    icon: 'fa-classic fa-light fa-circle-pause fa-fw',
                    class: '',
                    variant: 'warning'
                },
                {   id: '1', 
                    label: 'ไม่อนุมัติการใช้งาน',
                    value: '1',
                    icon: 'fa-classic fa-light fa-ban fa-fw',
                    class: '',
                    variant: 'danger'
                },
            ],
        },
        users: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '0', 
                    label: 'อนุมัติการใช้งาน',
                    value: '0',
                    icon: 'fa-classic fa-light fa-shield-check fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '2', 
                    label: 'พักการใช้งาน',
                    value: '2',
                    icon: 'fa-classic fa-light fa-circle-pause fa-fw',
                    class: '',
                    variant: 'warning'
                },
                {   id: '1', 
                    label: 'ไม่อนุมัติการใช้งาน',
                    value: '1',
                    icon: 'fa-classic fa-light fa-ban fa-fw',
                    class: '',
                    variant: 'danger'
                },
            ],
        },
        users_task_permission: {
            defaulted: true,
            options: [
                {   id: '0', 
                    label: 'เปิดการใช้งาน',
                    value: '0',
                    icon: 'fa-classic fa-light fa-play fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '1', 
                    label: 'ปิดการใช้งาน',
                    value: '1',
                    icon: 'fa-classic fa-light fa-stop fa-fw',
                    class: '',
                    variant: 'danger'
                },
            ],
        },
        external_user_work_status: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '0', 
                    label: 'อยู่ระหว่างการทำงาน',
                    value: '0',
                    icon: 'fa-classic fa-light fa-circle-play fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '1', 
                    label: 'สิ้นสุดการทำงาน',
                    value: '1',
                    icon: 'fa-classic fa-light fa-circle-stop fa-fw',
                    class: '',
                    variant: 'dark'
                }
            ],
        },
        type_a_student_import_file: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '0', 
                    label: 'นำเข้าไฟล์',
                    value: '0',
                    icon: 'fa-classic fa-light fa-circle-arrow-up fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },
                {   id: '1', 
                    label: 'ตรวจสอบข้อมูล',
                    value: '1',
                    icon: 'fa-classic fa-light fa-circle-info fa-fw',
                    class: '',
                    variant: 'outline-info'
                },   
                {   id: '2', 
                    label: 'ข้อมูลสมบูรณ์',
                    value: '2',
                    icon: 'fa-classic fa-light fa-circle-check fa-fw',
                    class: '',
                    variant: 'outline-success'
                },                                
                {   id: '3', 
                    label: 'ข้อมูลไม่สมบูรณ์',
                    value: '3',
                    icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
                    class: '',
                    variant: 'danger'
                },  
                {   id: '4', 
                    label: 'นำเข้าระบบ',
                    value: '4',
                    icon: 'fa-classic fa-light fa-circle-arrow-right fa-fw',
                    class: '',
                    variant: 'success'
                },                  
            ],
        },
    
        matching: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'ทั้งหมด',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '0', 
                    label: 'ตรงกัน',
                    value: '1',
                    icon: 'fa-classic fa-light fa-ban fa-fw',
                    class: '',
                    variant: 'danger'
                },
                {   id: '1', 
                    label: 'ไม่ตรงกัน',
                    value: '0',
                    icon: 'fa-classic fa-light fa-circle-check fa-fw',
                    class: '',
                    variant: 'success'
                }
            ],
        },       
    },
    
    category: {
        eb01_course: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'การจัดการ',
                    value: 'eb01-course',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },
                {   id: '4', 
                    label: 'ค่าใช้จ่าย',
                    value: 'eb01-expenses-eb01',
                    icon: 'fa-classic fa-regular fa-message-dollar fa-fw',
                    class: '',
                    variant: 'primary'
                },
                {   id: '1', 
                    label: 'ผลลัพธ์การเรียนรู้ของหลักสูตร (Learning Outcomes)',
                    value: 'eb01-learning-result',
                    icon: 'fa-classic fa-regular fa-chart-sine fa-fw',
                    class: '',
                    variant: 'primary'
                },
                {   id: '2', 
                    label: 'ผลกระทบและประโยชน์ที่คาดว่าจะได้รับ (Impact)',
                    value: 'eb01-course-benefit',
                    icon: 'fa-classic fa-regular fa-stars fa-fw',
                    class: '',
                    variant: 'primary'
                },
                {   id: '3', 
                    label: 'รายละเอียดการฝึกอบรม',
                    value: 'eb01-training-details',
                    icon: 'fa-classic fa-regular fa-person-chalkboard fa-fw',
                    class: '',
                    variant: 'primary'
                },

            ],
        },
        eb02_course: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'การจัดการ',
                    value: 'eb02-course',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },
                {   id: '1', 
                    label: 'รายละเอียดการฝึกอบรมที่ขออนุมัติ',
                    value: 'eb02-training-details',
                    icon: 'fa-classic fa-regular fa-person-chalkboard fa-fw',
                    class: '',
                    variant: 'primary'
                },                
                {   id: '2', 
                    label: 'ค่าใช้จ่าย',
                    value: 'eb02-expenses-eb02',
                    icon: 'fa-classic fa-regular fa-message-dollar fa-fw',
                    class: '',
                    variant: 'primary'
                },
            ]
        },     
        eb03_course: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'การจัดการ',
                    value: 'eb03-course',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },
                {   id: '1', 
                    label: 'รายละเอียดการจัดอบรม',
                    value: 'eb03-training-details',
                    icon: 'fa-classic fa-regular fa-person-chalkboard fa-fw',
                    class: '',
                    variant: 'primary'
                },                
            ]
        },   
        eb03_course_drilldown_eb04_eb05: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'แบบฟอร์ม',
                    value: 'eb03-course',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },
                {   id: '1', 
                    label: 'เอกสารรับรองจากสถานประกอบการ',
                    value: 'eb04-certification',
                    icon: 'fa-classic fa-light fa-certificate fa-fw',
                    class: '',
                    variant: 'primary'
                },
                {   id: '2', 
                    label: 'แบบประมินความพึงพอใจคุณภาพของหลักสูตร',
                    value: 'eb05-satisfaction-assessment',
                    icon: 'fa-classic fa-light fa-ballot-check fa-fw',
                    class: '',
                    variant: 'primary'
                },                
            ]
        },
        publicize_vacancies: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '1', 
                    label: 'ผู้ดูแลระบบ',
                    value: '1',
                    icon: 'fa-classic fa-light fa-place-of-worship fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '3', 
                    label: 'ผู้ประกอบการ',
                    value: '3',
                    icon: 'fa-classic fa-light fa-place-of-worship fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '4', 
                    label: 'ผู้ใช้งาน',
                    value: '4',
                    icon: 'fa-classic fa-light fa-place-of-worship fa-fw',
                    class: '',
                    variant: 'info'
                },
            ],
        },
        publicize_academy: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '1', 
                    label: 'ผู้ดูแลระบบ',
                    value: '1',
                    icon: 'fa-classic fa-light fa-place-of-worship fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '2', 
                    label: 'สถานศึกษา',
                    value: '2',
                    icon: 'fa-classic fa-light fa-place-of-worship fa-fw',
                    class: '',
                    variant: 'info'
                },
            ],
        },
        publicize_news_by: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '1', 
                    label: 'ผู้ดูแลระบบ',
                    value: '1',
                    icon: 'fa-classic fa-light fa-place-of-worship fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '2', 
                    label: 'สถานศึกษา',
                    value: '2',
                    icon: 'fa-classic fa-light fa-house-building fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '3', 
                    label: 'ผู้ประกอบการ',
                    value: '3',
                    icon: 'fa-classic fa-light fa-place-of-worship fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '4', 
                    label: 'ผู้ใช้งานภายนอก',
                    value: '4',
                    icon: 'fa-classic fa-light fa-house-building fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '5', 
                    label: 'EECO MMD',
                    value: '5',
                    icon: 'fa-classic fa-light fa-house-building fa-fw',
                    class: '',
                    variant: 'info'
                }                
            ],
        },
        publicize_news_type: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'secondary'
                },
                {   id: '0', 
                    label: 'ข่าวประชาสัมพันธ์ทั่วไป',
                    value: '0',
                    icon: 'fa-classic fa-light fa-comment fa-fw',
                    class: '',
                    variant: 'primary'
                },
                {   id: '1', 
                    label: 'กิจกรรม',
                    value: '1',
                    icon: 'fa-classic fa-light fa-calendar-lines fa-fw',
                    class: '',
                    variant: 'success'
                },           
            ],
        },        
        publicize_academy_and_course_types: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: '',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '0', 
                    label: 'สถาบัน',
                    value: '0',
                    icon: '',
                    class: '',
                    variant: 'success'
                },
                {   id: '1', 
                    label: 'หลักสูตร',
                    value: '1',
                    icon: '',
                    class: '',
                    variant: 'primary'
                },   
                {   id: '2', 
                    label: 'ฝึกอบรม',
                    value: '2',
                    icon: '',
                    class: '',
                    variant: 'info'
                },                               
            ],
        },            
        eec_nets_performance_types: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: '',
                    class: '',
                    variant: ''
                },
                {   id: '1', 
                    label: 'การพัฒนาทักษะบุคลากร (EEC Model Type B)',
                    value: '1',
                    icon: '',
                    class: '',
                    variant: 'success'
                },
                {   id: '2', 
                    label: 'การพัฒนาทักษะบุคลากรภาคอุตสาหกรรม (นอกเหนือจากรูปแบบ EEC Model Type B)',
                    value: '2',
                    icon: '',
                    class: '',
                    variant: 'primary'
                },
                {   id: '3', 
                    label: 'การขับเคลื่อนการศึกษาเพื่อรองรับการพัฒนาอุตสาหกรรมตามขอบเขตการดำเนินงานของศูนย์',
                    value: '3',
                    icon: '',
                    class: '',
                    variant: 'info'
                }                
            ],
        },
        expense: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '1', 
                    label: 'แบบฟอร์ม EB-01',
                    value: '1',
                    icon: 'fa-classic fa-light fa-badge-dollar fa-fw',
                    class: '',
                    variant: 'outline-primary'
                },
                {   id: '2', 
                    label: 'แบบฟอร์ม EB-02',
                    value: '2',
                    icon: 'fa-classic fa-light fa-badge-percent fa-fw',
                    class: '',
                    variant: 'outline-success'
                }
            ],
        },
        users: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: '',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '0', 
                    label: 'SUPER ADMIN',
                    value: '0',
                    icon: 'fa-classic fa-light fa-user-alien fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '1', 
                    label: 'ADMIN SYSTEM',
                    value: '1',
                    icon: 'fa-classic fa-light fa-user-astronaut fa-fw',
                    class: '',
                    variant: 'primary'
                },
                {   id: '2', 
                    label: 'USER EDU (สถานศึกษา)',
                    value: '2',
                    icon: 'fa-classic fa-light fa-user-graduate fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '3', 
                    label: 'USER ENT (สถานประกอบการ)',
                    value: '3',
                    icon: 'fa-classic fa-light fa-user-tie-hair fa-fw',
                    class: '',
                    variant: 'dark'
                },
                {   id: '5', 
                    label: 'EECO',
                    value: '5',
                    icon: 'fa-classic fa-light fa-users fa-fw',
                    class: '',
                    variant: 'orange'
                },
                {   id: '6', 
                    label: 'TNR (ผู้ฝึกสอน)',
                    value: '6',
                    icon: 'fa-classic fa-light fa-people-pants-simple fa-fw',
                    class: '',
                    variant: 'success'
                },
            ],
        },
        usersPermission: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: '',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '0', 
                    label: 'SUPER ADMIN',
                    value: '0',
                    icon: 'fa-classic fa-light fa-user-alien fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '1', 
                    label: 'ADMIN SYSTEM',
                    value: '1',
                    icon: 'fa-classic fa-light fa-user-astronaut fa-fw',
                    class: '',
                    variant: 'primary'
                },
                {   id: '2', 
                    label: 'USER EDU (สถานศึกษา)',
                    value: '2',
                    icon: 'fa-classic fa-light fa-user-graduate fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '3', 
                    label: 'USER ENT (สถานประกอบการ)',
                    value: '3',
                    icon: 'fa-classic fa-light fa-user-tie-hair fa-fw',
                    class: '',
                    variant: 'dark'
                },
                {   id: '4', 
                    label: 'USER EXTERNAL',
                    value: '4',
                    icon: 'fa-classic fa-light fa-people-pants-simple fa-fw',
                    class: '',
                    variant: 'green'
                },
                {   id: '5', 
                    label: 'EECO',
                    value: '5',
                    icon: 'fa-classic fa-light fa-users fa-fw',
                    class: '',
                    variant: 'orange'
                },
                {   id: '6', 
                    label: 'TNR (ผู้ฝึกสอน)',
                    value: '6',
                    icon: 'fa-classic fa-light fa-people-pants-simple fa-fw',
                    class: '',
                    variant: 'yellow'
                },
            ],
        },
        type_a_student_types: {
            defaulted: true,
            options: [
                {   id: '0', 
                    label: 'นักศึกษาเข้าใหม่',
                    value: '0',
                    icon: 'fa-classic fa-light fa-user-plus fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '1', 
                    label: 'อยู่ระหว่างการศึกษา',
                    value: '1',
                    icon: 'fa-classic fa-light fa-user-clock fa-fw',
                    class: '',
                    variant: 'primary'
                }, 
                {   id: '2', 
                    label: 'สำเร็จการศึกษา',
                    value: '2',
                    icon: 'fa-classic fa-light fa-user-graduate fa-fw',
                    class: '',
                    variant: 'success'
                },                 
            ]
        },
        type_a_welfare_support_time: {
            defaulted: true,
            options: [
                {   id: '0',
                    label: '1 ภาคการศึกษา',
                    value: '0',
                },
                {   id: '1',
                    label: '1 ปีการศึกษา',
                    value: '1',
                },
                {   id: '2',
                    label: '1 ปี + 1 เทอม',
                    value: '2',
                },
                {   id: '3',
                    label: '2 ปีการศึกษา',
                    value: '3',
                },
                {   id: '4',
                    label: '2 ปี + 1 เทอม',
                    value: '4',
                },
                {   id: '5', 
                    label: '3 ปีการศึกษา',
                    value: '5',
                },
                {   id: '6', 
                    label: '3 ปี + 1 เทอม',
                    value: '6',
                },
                {   id: '7',
                    label: 'ตลอดระยะเวลาของหลักสูตร',
                    value: '7',
                },
            ],
        }, 
        type_a_student_import_file_type: {
            defaulted: true,
            options: [
                {   id: '0',
                    label: 'ไฟล์จำนวนนักศึกษาจำแนกตามสถานศึกษา',
                    value: '0',
                },
            ]
        }                    
    },
    
    usersPermission: {
         mainType: {
            defaulted: true,
            options: [
                {   id: '', 
                    label: 'กรุณาระบุ',
                    value: '',
                    icon: '',
                    class: '',
                    variant: 'outline-secondary'
                },
                {   id: '0', 
                    label: 'SUPER ADMIN',
                    value: '0',
                    icon: 'fa-classic fa-light fa-user-alien fa-fw',
                    class: '',
                    variant: 'success'
                },
                {   id: '1', 
                    label: 'ADMIN SYSTEM',
                    value: '1',
                    icon: 'fa-classic fa-light fa-user-astronaut fa-fw',
                    class: '',
                    variant: 'primary'
                },
                {   id: '2', 
                    label: 'USER EDU',
                    value: '2',
                    icon: 'fa-classic fa-light fa-user-graduate fa-fw',
                    class: '',
                    variant: 'info'
                },
                {   id: '3', 
                    label: 'USER ENT (สถานประกอบการ)',
                    value: '3',
                    icon: 'fa-classic fa-light fa-user-tie-hair fa-fw',
                    class: '',
                    variant: 'dark'
                },
                {   id: '4', 
                    label: 'USER EXTERNAL',
                    value: '4',
                    icon: 'fa-classic fa-light fa-people-pants-simple fa-fw',
                    class: '',
                    variant: 'green'
                },
                {   id: '5', 
                    label: 'EECO',
                    value: '5',
                    icon: 'fa-classic fa-light fa-users fa-fw',
                    class: '',
                    variant: 'orange'
                },
                {   id: '6', 
                    label: 'TNR (ผู้ฝึกสอน)',
                    value: '6',
                    icon: 'fa-classic fa-light fa-people-pants-simple fa-fw',
                    class: '',
                    variant: 'yellow'
                },
            ],
        },
    },

    /** 
        graduation_flag: {
            default: {
                defaulted: true,
                options: [
                    {   id: '0', 
                        label: 'นักศึกษาเข้าใหม่',
                        value: '0',
                        icon: 'fa-classic fa-light fa-user-plus fa-fw',
                        class: '',
                        variant: 'success'
                    },
                    {   id: '1', 
                        label: 'อยู่ระหว่างการศึกษา',
                        value: '1',
                        icon: 'fa-classic fa-light fa-user fa-fw',
                        class: '',
                        variant: 'warning'
                    },
                    {   id: '2', 
                        label: 'จบการศึกษา',
                        value: '1',
                        icon: 'fa-classic fa-light fa-user-graduate fa-fw',
                        class: '',
                        variant: 'danger'
                    }
                ],
            },
        },

        enterprise_flag: {
            default: {
                defaulted: true,
                options: [
                    {   id: '0', 
                        label: 'ตัวแทนสถานประกอบการ',
                        value: '0',
                    },
                    {   id: '1', 
                        label: 'ผู้ใช้งานภายนอก',
                        value: '1',
                    }
                ],
            },
        },  

        duration: {
            default: {
                defaulted: true,
                options: [
                    {   id: '0',
                        label: '1 ภาคการศึกษา',
                        value: '0',
                    },
                    {   id: '1',
                        label: '1 ปีการศึกษา',
                        value: '1',
                    },
                    {   id: '2',
                        label: '1 ปี + 1 เทอม',
                        value: '2',
                    },
                    {   id: '3',
                        label: '2 ปีการศึกษา',
                        value: '3',
                    },
                    {   id: '4',
                        label: '2 ปี + 1 เทอม',
                        value: '4',
                    },
                    {   id: '5', 
                        label: '3 ปีการศึกษา',
                        value: '5',
                    },
                    {   id: '6', 
                        label: '3 ปี + 1 เทอม',
                        value: '6',
                    },
                    {   id: '7',
                        label: 'ตลอดระยะเวลาของหลักสูตร',
                        value: '7',
                    },
                ],
            },
        },   

        welfare: {
            status: {
                defaulted: true,
                options: [
                    {   id: '0', 
                        label: 'ได้รับการสนับสนุน',
                        value: '0',
                    },
                    {   id: '1', 
                        label: 'ไม่ได้รับการสนับสนุน',
                        value: '1',
                    }
                ],
            },
        },  

        industry_type: {
            default: {
                defaulted: true,
                options: [
                    {   id: '', 
                        label: 'กรุณาระบุ',
                        value: '',
                        class: '',
                    },
                    {   id: '1', 
                        label: 'อุตสาหกรรมในพื้นที่อีอีซี ที่ไม่ได้รับบีโอไอ',
                        value: '1',
                        class: '',
                    },
                    {   id: '2', 
                        label: 'อุตสาหกรรมนอกพื้นที่อีอีซี ที่ไม่ได้รับบีโอไอ',
                        value: '2',
                        class: '',
                    },
                    {   id: '3', 
                        label: 'อุตสาหกรรมในพื้นที่อีอีซี ที่ยังได้รับการยกเว้นภาษีเงินได้นิติบุคคลจากบีโอไอ',
                        value: '3',
                        class: '',
                    },{   id: '4', 
                        label: 'อุตสาหกรรมนอกพื้นที่อีอีซี ที่ยังได้รับการยกเว้นภาษีเงินได้นิติบุคคลจากบีโอไอ',
                        value: '4',
                        class: '',
                    },
                ],
            },
        },

        recheckstatus: {
            default: {
                defaulted: true,
                options: [
                    {   id: '0', 
                        label: 'ผ่าน',
                        value: '0',
                    },
                    {   id: '1', 
                        label: 'ไม่ผ่าน',
                        value: '1',
                    }
                ],
            },
        },

        recommend: {
            default: {
                defaulted: true,
                options: [
                    {   id: '0', 
                        label: 'สมควรอนุมัติ',
                        value: '0',
                    },
                    {   id: '1', 
                        label: 'ไม่สมควรอนุมัติ',
                        value: '1',
                    }
                ],
            },
        },

        notification: {
            default: {
                defaulted: true,
                options: [
                    {   id: '', 
                        label: '',
                        value: '',
                        icon: 'a-classic fa-light fa-circle-ellipsis fa-fw',
                        class: '',
                        variant: 'outline-primary'
                    },
                    {   id: '0', 
                        label: 'แจ้งเตือนผ่าน SMS',
                        value: '0',
                        icon: 'fa-classic fa-light fa-message fa-fw',
                        class: '',
                        variant: 'outline-success'
                    },
                    {   id: '1', 
                        label: 'แจ้งเตือนผ่าน E-MAIL',
                        value: '1',
                        icon: 'fa-classic fa-light fa-envelope fa-fw',
                        class: '',
                        variant: 'outline-info'
                    }
                ],
            },
        },

        submenu: {
            eb02: {
                defaulted: true,
                options: [
                    {   id: '', 
                        label: 'รายละเอียด',
                        value: 'eb02-request',
                        icon: 'a-classic fa-light fa-pen-to-square fa-fw',
                        class: '',
                        variant: 'primary'
                    },
                    {   id: '1', 
                        label: 'รายละเอียดการฝึกอบรม',
                        value: 'eb02-request-details',
                        icon: 'fa-classic fa-light fa-rectangle-list fa-fw',
                        class: '',
                        variant: 'primary'
                    },
                    {   id: '2', 
                        label: 'งบประมาณ',
                        value: 'eb02-expenses-eb02',
                        icon: 'fa-classic fa-light fa-sack-dollar fa-fw',
                        class: '',
                        variant: 'primary'
                    }
                ],
            },
            eb03: {
                defaulted: true,
                options: [
                    {   id: '', 
                        label: 'รายละเอียด',
                        value: 'eb02-request',
                        icon: 'a-classic fa-light fa-pen-to-square fa-fw',
                        class: '',
                        variant: 'primary'
                    },
                    {   id: '1', 
                        label: 'รายละเอียดการจัดอบรม',
                        value: 'eb03-training-report-detail',
                        icon: 'a-classic fa-light fa-square-poll-horizontal fa-fw',
                        class: '',
                        variant: 'primary'
                    },
                    {   id: '2', 
                        label: 'ข้อมูลผู้ประกอบการ',
                        value: 'eb03-certification-eb-04',
                        icon: 'fa-classic fa-light fa-solid fa-briefcase fa-fw',
                        class: '',
                        variant: 'primary'
                    },
                    {   id: '3', 
                        label: 'ข้อมูลวิทยากร',
                        value: 'eb03-lecturer',
                        icon: 'fa-classic fa-light fa-users fa-fw',
                        class: '',
                        variant: 'primary'
                    },
                    {   id: '4', 
                        label: 'รายการเอกสารแนบ',
                        value: 'eb03-attachment-file',
                        icon: 'fa-classic fa-light fa-paperclip fa-fw',
                        class: '',
                        variant: 'primary'
                    }
                ],
            },
        }

        // institution: {
        //     defaulted: true,
        //     options: [
        //         {   id: '', 
        //             label: 'รายละเอียด',
        //             value: '',
        //             icon: 'a-classic fa-light fa-pen-to-square fa-fw',
        //             class: '',
        //             variant: 'primary'
        //         },
        //         {   id: '1', 
        //             label: 'จํานวนนักเรียนแยกระดับชั้น',
        //             value: 'student-grade-level',
        //             icon: 'a-classic fa-light fa-screen-users fa-fw',
        //             class: '',
        //             variant: 'primary'
        //         },
        //         {   id: '2', 
        //             label: 'ข้อมูลหลักสูตร / คณะ / สาขาวิชา',
        //             value: 'course-faculty-major-information',
        //             icon: 'fa-classic fa-light fa-solid fa-graduation-cap fa-fw',
        //             class: '',
        //             variant: 'primary'
        //         },
        //     ],
        // },
    */
};